export enum MeetingStatus {
  SCHEDULED = "scheduled",
  CANCELLED = "cancelled",
  RESCHEDULED = "rescheduled"
}
